export default {
	state: {
		timeouts: []
	},

	actions: {
		set(actionContext, timeout) {
			return new Promise((resolve, reject) => {
				try {
					var filteredtimeout = actionContext.state.timeouts.filter(x => x.name == timeout.name)[0]

					if (filteredtimeout != null)
						actionContext.commit("clear", filteredtimeout.name)

					actionContext.commit("set", timeout)

					resolve()
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		clearAll(actionContext) {
			return new Promise((resolve, reject) => {
				try {
					for (var i = 0; i < actionContext.state.timeouts.length; i++) {
						var timeout = actionContext.state.timeouts[i]

						actionContext.commit("clear", timeout.name)

						resolve()
					}
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		}
	},

	mutations: {
		set(state, timeout) {
			var id = setTimeout(timeout.callback, timeout.timeout)

			state.timeouts.push({ name: timeout.name, id })
		},
		clear(state, timeoutName) {
			var timeouts = state.timeouts.filter(x => x.name == timeoutName)

			for (var i = 0; i < timeouts.length; i++) {
				var timeout = timeouts[i]

				clearTimeout(timeout.id)

				state.timeouts = state.timeouts.filter(x => x.name != timeout.name)
			}
		}
	},

	namespaced: true
}